import { axios } from '@/services/axios';

const getPlatformNumbers = async (numberId, accountScope) => {
    const res = await axios.get(
        `/PlatformNumbers/${numberId}?EditOptions=true`,
        {
            headers: {
                'X-RequestScope': accountScope,
            },
        },
    );
    return res.data;
};

export default getPlatformNumbers;
